export default __webpack_public_path__ + "static/media/new-view-pdf.e2417288.png";